<template>
  <div class="list-wrapper">
    <div class="main-title">
      <el-tabs v-model="type" @tab-click="handleClick">
        <el-tab-pane 
          v-for="(item) in nav.children" 
          :key="item.id.toString()"
          :name="item.id.toString()"
        >
          <span slot="label">
            {{item.name}} (
               <span>{{item.countApply}}</span>
            )
          </span>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="list-right">
      <AppLoader v-if="loading" loaderType="appList" :height="720"/>
      <div
        class="list-item"
        v-for="(record, index) in dataSource"
        v-bind:key="record.id + '' + index"
        @click="handleItemClick(record.id)"
      >
        <div class="row-flex">
          <div class="icon-box" :style="{ background: '#fff' }">
            <img :src="record.applyImg" :alt="record.applyName" />
          </div>
          <div class="item-info">
            <div class="title">{{ record.applyName }}</div>
            <div v-if="record.labels.length > 0" class="tags">
              <div class="tag" v-for="(tag, tagIndex) in record.labels.split(',')" :key="tagIndex">
                {{ tag }}
              </div>
            </div>
          </div>
          <div class="row-desc" :title="record.applyMessage">{{ record.applyMessage }}</div>
          <el-button
            v-if="record.payStatus === 'PAY' && userInfo"
            class="action-btn"
            @click="manage($event, record.id)"
            >管理应用</el-button
          >
          <el-button v-else-if="record.payStatus === 'UNSUPPORTED'" class="action-btn disabled"
            >暂不支持此项目</el-button
          >
          <el-button
            :loading="loadingId === record.id"
            v-else
            class="action-btn"
            @click="buynow($event, record.id)"
            >立即选购</el-button
          >
        </div>
      </div>
      <Empty
        v-if="!(dataSource && dataSource.length) && !loading"
        :icon="
          hasKeyword
            ? 'https://gt-toolbox.oss-cn-beijing.aliyuncs.com/gt-toolbox/229c3bef-a6ce-4c11-8727-7d34b505e454.png'
            : ''
        "
        y
        message="抱歉，暂无相关应用哦"
      />
    </div>
    <SelectType v-if="showSelect" @submit="sureBuy" @hide="showSelect = false"/>
    <div v-if="pagination" class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="pagination.count"
        :page-size="pagination.pageSize"
        :current-page="pagination.page"
        hide-on-single-page
        @current-change="onChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import Empty from '@/components/Empty'
import AppLoader from '@/components/ContentLoader/AppLoader'
import { checkLogin } from '@/utils/util'
import SelectType from '@/components/AppList/selectType'
export default {
  props: {
    dataSource: {
      type: Array,
      default: () => []
    },
    pagination: Object,
    onChange: Function,
    requery: Function,
    loading: {
      type: Boolean,
      default: true
    },
    height: {
      type: Number,
      default: 264
    },
    scene: {
      type: Number,
      default: -1
    },
    showExtra: {
      type: Boolean,
      default: true
    },
    hasKeyword: {
      type: Boolean,
      default: true
    },
    nav: {
      type: Object
    }
  },
  components: {
    AppLoader,
    Empty,
    SelectType
  },
  data () {
    return {
      applyTypeStr: { 'INNER': '小程序', 'LIGHT': '轻应用', 'ABROAD': '小程序' },
      userInfo: JSON.parse(window.localStorage.getItem('userInfoApp')),
      showSelect: false,
      selectId: null,
      type: '1',
    }
  },
  computed: {
    ...mapState({
      loadingId: state => state.home.loadingId,
      tagList: state => {
        let arr = state.home.tagList.sort((a, b) => a.orderNum - b.orderNum)
        arr.map(item => item.children.sort((a, b) => a.orderNum - b.orderNum))
        return arr
      }
    })
  },
  methods: {
    ...mapActions('home', ['pay', 'manageApp']),
    ...mapMutations('login', ['toggleLoginModalVisible']),
    handleItemClick (id) {
      this.$router.push(`/application/detail/${id}?noSearch=true&yiwu=true`)
    },
    handleClick() {
      this.$emit('setType', this.type)
    },
    buynow (e, id) {
      e.stopPropagation()
      if (!checkLogin()) {
        this.toggleLoginModalVisible()
        return
      }
      this.showSelect = true
      this.selectId = id
    },
    sureBuy (value) {
      const self = this
      const id = this.selectId
      this.pay({
        id,
        value,
        type: 'yiwu',
        callback () {
          if (self.requery) self.requery()
        }
      })
    },
    toClassify (id) {
      this.$parent.changeType(id)
    },
    manage (e, id) {
      e.stopPropagation()
      if (!checkLogin()) {
        this.toggleLoginModalVisible()
        return
      }
      const self = this
      this.manageApp({
        id,
        type: 'yiwu',
        callback () {
          if (self.requery) self.requery()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.list-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  background: #fff;
  .main-title{
    width: 801px;
    background: #fff;
    font-size: 18px;
    color: #333;
    font-weight: 600;
    height: 60px;
    line-height: 60px;
    border-bottom: 1px solid #D1D1D1;
    padding: 0 45px;
    position: relative;
    /deep/ .el-tabs__item{
      font-size: 18px;
    }
    /deep/ .el-tabs__nav-wrap::after{
      display: none;
    }
    /deep/ .el-tabs__nav-next, /deep/ .el-tabs__nav-prev{
      height: 60px;
      display: flex;
      align-items: center;
    }
  }
  .list-left {
    width: 216px;
    background: #ffffff;
    padding: 32px 30px 140px;
    display: inline-block;
    .apply-all {
      cursor: pointer;
      font-family: PingFangSC-Semibold;
      font-size: 16px;
      color: #333333;
      &.classify-two-selected {
        color: #0091ff;
      }
    }
    .apply-classify {
      margin-top: 30px;
      .classify-one {
        margin-bottom: 3px;
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #333333;
        cursor: pointer;
      }
      .classify-two {
        width: 108px;
        display: inline-block;
        margin-top: 10px;
        font-family: PingFangSC-Regular;
        font-size: 13px;
        color: #333333;
        cursor: pointer;
      }
      .classify-two-selected {
        color: #0091ff;
      }
    }
  }
  .list-right {
    width: 801px;
    padding: 30px 45px 20px;
    display: block;
    background: #ffffff;
    // margin: 0 auto;
    .list-item {
      width: 100%;
      height: 120px;
      display: inline-block;
      padding-top: 40px;
      border-bottom: 1px solid #ebebeb;
      cursor: pointer;
      .row-flex {
        display: flex;
        position: relative;
      }
      .icon-box {
        background: #ffffff;
        border: 1px solid #e9e9e9;
        border-radius: 20px;
        width: 98px;
        height: 98px;
        display: inline-block;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          box-shadow: 0px 4px 13px 0px rgba(0, 0, 0, 0.08);
        }
        img {
          width: 67px;
          height: 67px;
        }
      }
      .item-info {
        position: absolute;
        left: 130px;
        top: 0;
        vertical-align: top;
        align-items: center;
        display: flex;
        justify-content: center;
        .title {
          display: inline-block;
          height: 30px;
          margin-right: 21px;
          font-family: PingFangSC-Semibold;
          font-size: 21.33px;
          color: #333333;
          letter-spacing: 0;
        }
        .tags {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
        }
        .tag {
          font-family: PingFangSC-Light;
          font-size: 12px;
          color: #000000;
          letter-spacing: 0;
          text-align: center;
          display: inline-block;
          width: 60px;
          height: 24px;
          background: #efefef;
          border-radius: 12px;
          line-height: 24px;
          padding: 0 10px;
          margin-right: 20px;
        }
      }
      .row-desc {
        position: absolute;
        width: 450px;
        left: 130px;
        top: 56px;
        font-family: PingFangSC-Light;
        font-size: 12px;
        color: #000000;
        // height: 51px;
        letter-spacing: 0;
        // text-align: justify;
        // display: -webkit-box;
        // overflow: hidden;
        // white-space: normal !important;
        // text-overflow: ellipsis;
        // word-wrap: break-word;
        // -webkit-line-clamp: 3;
        // -webkit-box-orient: vertical;
      }
      .action-btn {
        position: absolute;
        top: 0;
        right: 0;
        width: 161px;
        height: 40px;
        margin-left: 179px;
        border: 1px solid #000000;
        background: #ffffff;
        color: #000000;
        border-radius: 0;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        text-align: center;
        padding: 0;
        &:hover {
          color: #ffffff;
          background: #000000;
          border: none;
        }
        &.disabled {
          color: #ffffff;
          background: grey;
          border: none;
          cursor: not-allowed;
        }
      }
    }
    // .list-item:nth-child(even) {
    //   margin-left: 120px;
    // }
    // .list-item:nth-child(n + 3) {
    //   margin-top: 39px;
    // }
  }
  .pagination {
    // margin-top: 20px;
    text-align: right;
    width: 100%;
    margin-right: 30px;
    padding-bottom: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppList/tzIndex.vue